import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';

import { API_HOST } from '../../config/app-const';

const state = {
  carmaAiFiltration: {
    isBusy: false,
    data: null,
    error: null,
    pagination: null,
    testIsBusy: false
  },
  carmaAiFiltrationTags: {
    isBusy: false,
    data: null,
    error: null,
  },
  carmaAiFiltrationPrivateTags: {
    isBusy: false,
    data: null,
    error: null,
  }
};

const mutations = {
  LOAD_CARMA_AI_FILTRATION_BUSY: (state, payload) => {
    state.carmaAiFiltration.isBusy = payload;
  },
  LOAD_CARMA_AI_FILTRATION_SUCCESS: (state, payload) => {
    if(Array.isArray(state.carmaAiFiltration.data?.data) && Array.isArray(payload.data?.data) && payload?.data?.pagination?.currentPage > 1) {
      state.carmaAiFiltration.data.data = [...state.carmaAiFiltration.data?.data, ...payload.data?.data];
      state.carmaAiFiltration.data.pagination = payload.data?.pagination;
    }
    else state.carmaAiFiltration.data = payload.data;
    state.carmaAiFiltration.error = null;
  },
  LOAD_CARMA_AI_FILTRATION_FAIL: (state, payload) => {
    state.carmaAiFiltration.data = null;
    state.carmaAiFiltration.error = payload;
  },

  CREATE_CARMA_AI_FILTRATION_BUSY: (state, payload) => {
    state.carmaAiFiltration.isBusy = payload;
  },
  CREATE_CARMA_AI_FILTRATION_SUCCESS: (state, payload) => {
    state.carmaAiFiltration.data = payload;
    state.carmaAiFiltration.error = null;
  },
  CREATE_CARMA_AI_FILTRATION_FAIL: (state, payload) => {
    state.carmaAiFiltration.data = null;
    state.carmaAiFiltration.error = payload;
  },

  UPDATE_CARMA_AI_FILTRATION_BUSY: (state, payload) => {
    state.carmaAiFiltration.isBusy = payload;
  },
  UPDATE_CARMA_AI_FILTRATION_SUCCESS: (state, payload) => {
    state.carmaAiFiltration.data = payload;
    state.carmaAiFiltration.error = null;
  },
  UPDATE_CARMA_AI_FILTRATION_FAIL: (state, payload) => {
    state.carmaAiFiltration.data = null;
    state.carmaAiFiltration.error = payload;
  },

  DELETE_CARMA_AI_FILTRATION_BUSY: (state, payload) => {
    state.carmaAiFiltration.isBusy = payload;
  },
  DELETE_CARMA_AI_FILTRATION_SUCCESS: (state, payload) => {
    state.carmaAiFiltration.error = null;
  },
  DELETE_CARMA_AI_FILTRATION_FAIL: (state, payload) => {
    state.carmaAiFiltration.data = null;
    state.carmaAiFiltration.error = payload;
  },
  LOAD_CARMA_AI_FILTRATION_TAGS_BUSY: (state, payload) => {
    state.carmaAiFiltrationTags.isBusy = payload;
  },
  LOAD_CARMA_AI_FILTRATION_TAGS_SUCCESS: (state, payload) => {
    state.carmaAiFiltrationTags.data = payload;
    state.carmaAiFiltrationTags.error = null;
  },
  LOAD_CARMA_AI_FILTRATION_TAGS_FAIL: (state, payload) => {
    state.carmaAiFiltrationTags.error = payload;
    state.carmaAiFiltrationTags.data = null;
  },
  LOAD_CARMA_AI_FILTRATION_PRIVATE_TAGS_BUSY: (state, payload) => {
    state.carmaAiFiltrationPrivateTags.isBusy = payload;
  },
  LOAD_CARMA_AI_FILTRATION_PRIVATE_TAGS_SUCCESS: (state, payload) => {
    state.carmaAiFiltrationPrivateTags.data = payload;
    state.carmaAiFiltrationPrivateTags.error = null;
  },
  LOAD_CARMA_AI_FILTRATION_PRIVATE_TAGS_FAIL: (state, payload) => {
    state.carmaAiFiltrationPrivateTags.error = payload;
    state.carmaAiFiltrationPrivateTags.data = null;
  },
  LOAD_AI_FILTRATION_TEST_BUSY: (state, payload) => {
    state.carmaAiFiltrationTags.testIsBusy = payload;
  }
};

const actions = {
  getCarmaAiFiltration: ({ commit, rootState }, { projectId, pagination, scope }) => {
    commit('LOAD_CARMA_AI_FILTRATION_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    let query = '';
    if(pagination) {
      query = '?';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }

    if (scope) {
      if (!query) {
        query = '?'
      } else {
        query += '&';
      }
      query += 'scope=' + encodeURIComponent(scope);
    }

    return Axios
      .get(`${API_HOST}/projects/${projectId}/open_ai_project/ai_filtration_rules${query}`, config)
      .then(response => {
        commit('LOAD_CARMA_AI_FILTRATION_SUCCESS', response.data)
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_CARMA_AI_FILTRATION_FAIL', error)
      })
      .finally(() => commit('LOAD_CARMA_AI_FILTRATION_BUSY', false));
  },

  createCarmaAiFiltration: ({ commit, rootState }, { projectId, data }) => {
    commit('CREATE_CARMA_AI_FILTRATION_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios
      .post(`${API_HOST}/projects/${projectId}/open_ai_project/ai_filtration_rules`, 
      data,
      config)
      .then(response => {
        commit('CREATE_CARMA_AI_FILTRATION_SUCCESS', response.data)
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('carma_ai.messages.success')
        });
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('CREATE_CARMA_AI_FILTRATION_FAIL', error)
      })
      .finally(() => commit('CREATE_CARMA_AI_FILTRATION_BUSY', false));
  },

  updateCarmaAiFiltration: ({ commit, rootState }, { projectId, data }) => {
    commit('UPDATE_CARMA_AI_FILTRATION_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios
      .put(`${API_HOST}/projects/${projectId}/open_ai_project/ai_filtration_rules/${data.id}`, 
      data,
      config)
      .then(response => {
        commit('UPDATE_CARMA_AI_FILTRATION_SUCCESS', response.data)
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('carma_ai.messages.success')
        });
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('UPDATE_CARMA_AI_FILTRATION_FAIL', error)
      })
      .finally(() => commit('UPDATE_CARMA_AI_FILTRATION_BUSY', false));
  },

  deleteCarmaAiFiltration: ({ commit, rootState }, { projectId, aiFiltrationId }) => {
    commit('DELETE_CARMA_AI_FILTRATION_BUSY', true);

    const { accessToken } = rootState.user.user.data;

    const config = {
      headers: { Authorization: `Token token=${accessToken}` },
    };

    return Axios
    .delete(`${API_HOST}/projects/${projectId}/open_ai_project/ai_filtration_rules/${aiFiltrationId}`, 
      config)
      .then(response => {
        commit('DELETE_CARMA_AI_FILTRATION_SUCCESS', {})
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('carma_ai.messages.delete_success')
        });
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('DELETE_CARMA_AI_FILTRATION_FAIL', error)
      })
      .finally(() => commit('DELETE_CARMA_AI_FILTRATION_BUSY', false));
  },
  getFiltrationRuleTags: ({ commit, rootState }, { projectId, pagination }) => {
    commit("LOAD_CARMA_AI_FILTRATION_TAGS_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/projects/${projectId}/open_ai_project/ai_filtration_rules/tags`, config)
      .then(response => {
        commit("LOAD_CARMA_AI_FILTRATION_TAGS_SUCCESS", response.data.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_CARMA_AI_FILTRATION_TAGS_FAIL", error);
      })
      .finally(() => commit("LOAD_CARMA_AI_FILTRATION_TAGS_BUSY", false));
  },
  getFiltrationRulePrivateTags: ({ commit, rootState }, { projectId, pagination }) => {
    commit("LOAD_CARMA_AI_FILTRATION_PRIVATE_TAGS_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/projects/${projectId}/open_ai_project/ai_filtration_rules/private_tags`, config)
      .then(response => {
        commit("LOAD_CARMA_AI_FILTRATION_PRIVATE_TAGS_SUCCESS", response.data.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_CARMA_AI_FILTRATION_PRIVATE_TAGS_FAIL", error);
      })
      .finally(() => commit("LOAD_CARMA_AI_FILTRATION_PRIVATE_TAGS_BUSY", false));
  },
  runTest: ({ commit, rootState }, { projectId, data }) => {

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    commit('LOAD_AI_FILTRATION_TEST_BUSY', true);

    const url = `${API_HOST}/projects/${projectId}/open_ai_project/ai_filtration_rules/test`;
    return Axios.post(url, data, config)
      .then(r => {
        return r.data.data;
      })
      .catch((error) => {
        console.error(error);
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
      }).finally(() => commit("LOAD_AI_FILTRATION_TEST_BUSY", false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};